import React, { Component } from 'react';
import { Form, Button, ModalFooter, FormGroup, CustomInput, Input } from 'reactstrap';
import FormInput from './formInput';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { addRelationGroups } from '../../../_pages/Admin/RelationGroups/relationGroupsFormData';
import { orgFormData } from '../../../_pages/Admin/Organisation/component/orgFormData';
import './index.css';
import Aux from '../Hoc';


class DynamicForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formData: this.props.data,
            submitted: false,
            formIsValid: false,
            showSwal: true,
            showResponseModal: false,
            addRelationGroupData: null,
            monthsArrRoot: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
            monthsArr: [],
            daysArr: []
        };
    }

    componentDidMount() {

        if (this.props.dobControlBool) {

            let daysArr = [];


            const updatedData = [...this.state.formData]
            const monthElement = updatedData[1]
            const yearElement = updatedData[0]


            if (monthElement.value) {
                const leapyear = (year) => {
                    return year % 100 === 0 ? year % 400 === 0 : year % 4 === 0;
                }

                const server_year = new Date(yearElement.validation.server_time).getYear() + 1900;
                const server_mon = new Date(yearElement.validation.server_time).getMonth() + 1;
                const server_day = new Date(yearElement.validation.server_time).getDate();



                const currentYearIsLeapYear = leapyear(parseInt(yearElement.value, 10))

                const MonthCheckForTotalDates = monthElement.value == 1 || monthElement.value == 3 || monthElement.value == 5 || monthElement.value == 7 || monthElement.value == 8 || monthElement.value == 10 || monthElement.value == 12 ? 31 : monthElement.value == 2 ? currentYearIsLeapYear ? 29 : 28 : 30

                const CheckDaysOnCurrentMonth = yearElement.value == server_year && monthElement.value == server_mon ? server_day : MonthCheckForTotalDates

                for (var i = 0; i < CheckDaysOnCurrentMonth; i++) {
                    daysArr.push(i + 1)
                }
                yearElement.value = `${yearElement.value}`
                yearElement.valid = this.isValidHandler(yearElement.value, yearElement.validation, yearElement.type, yearElement.regex);
                if (yearElement.fieldValidation)
                    yearElement.fieldValid = this.isFieldValidHandler(yearElement.value, yearElement.fieldValidation, yearElement.type, yearElement.key)



                const monthsArrRoot = [...this.state.monthsArrRoot]
                const monthsArr = monthsArrRoot.filter((month, index) => {
                    if (yearElement.value == server_year) {
                        return index < server_mon
                    } else if (yearElement.value > server_year) {
                        return false
                    } else {
                        if (yearElement.value < yearElement.validation.minYear) {
                            return false
                        } else {
                            return true
                        }
                    }
                })


                updatedData[1] = monthElement;
                updatedData[0] = yearElement;

                this.setState({
                    monthsArr,
                    daysArr,
                    formData: updatedData
                })
            }
        }
    }

    isValidHandler = (updatedValue, validation, type, regexText) => {

        let isValid = true;

        if (validation.required && type !== 'checkbox') {
            isValid = updatedValue.trim() !== '' && isValid;
        }
        else if (validation.required && type === 'checkbox') {
            isValid = updatedValue && isValid;
        }
        if (validation.min || validation.max) {
            isValid = (updatedValue.trim().length === validation.min || updatedValue.trim().length === 0) && isValid;
        }
        if (validation.minYear) {
            isValid = (updatedValue.trim() > validation.minYear && updatedValue.trim() <= (validation.maxYear)) && isValid;
        }

        if (regexText && validation.required) {
            let regex = new RegExp(regexText)
            isValid = regex.test(updatedValue)
        }

        return isValid;
    }
    isFieldValidHandler = (updatedValue, validation, type, fieldName = '') => {
        let isValid = true;

        if (
            fieldName == "full_name" ||
            fieldName == "short_name" ||
            fieldName == "city" ||
            fieldName == "state" || fieldName == "pincode" || fieldName == "email" || fieldName == "organisation_name" && validation && validation.required) {
            let regex = new RegExp(validation.required);
            isValid = regex.test(updatedValue);
        }

        return isValid;
    }

    handleSubmit = (event, dispatch) => {
        const relationData = [];
        event.preventDefault();
        const formData = {};
        const updatedData = this.state.formData;

        this.setState({
            submitted: true
        })

        let formIsValid = true;
        for (let identifiers in updatedData) {
            formIsValid = updatedData[identifiers].valid && formIsValid;
            if (updatedData[identifiers].key === 'pincode') {
                formIsValid = updatedData[identifiers].fieldValid && formIsValid;
            }
        }
        const sellerData = {};


        if (!formIsValid) {
            return; // Exit the function if the form is not valid
        }

        if (formIsValid) {
            if (this.props.formName !== 'inlineCheckbox1' && this.props.formName !== 'inlineCheckbox2') {


                this.state.formData.map(function (element) {
                    if (element.type === 'number') {

                        sellerData[element.key] = +element.value;
                    }

                    if (element.type !== 'number') {

                        sellerData[element.key] = element.value;
                    }

                    if (element.type === 'checkbox') {

                        sellerData[element.key] = element.value === '' || element.value === false || element.value === 'false' ? false : true;
                    }
                });

            }
            else {
                this.state.formData.map(
                    (element) => {

                        if ((element.value !== '' && element.value !== 'false' && element.value !== false) && element.type === 'checkbox') {

                            relationData.push(element.key);
                        }
                    }
                )

            }

            if (this.props.formName === 'nonSubmittableForm') {
                this.props.relationToggle();
            }
            else {
                if ((this.props.formName === 'inlineCheckbox1' || this.props.formName === 'inlineCheckbox2') || this.props.formName === 'inlineOrgAdmin') {
                    const fd = this.props.formName === 'inlineCheckbox1' ? addRelationGroups : this.props.formName === 'inlineOrgAdmin' ? this.state.formData : orgFormData;
                    fd.map(
                        (element, i) => {

                            if (element.type === 'number') {
                                sellerData[element.key] = +element.value;
                            }

                            if (element.type !== 'number') {

                                sellerData[element.key] = element.value;
                            }

                            if (element.type === 'checkbox') {
                                sellerData[element.key] = element.value === '' || element.value === false || element.value === 'false' ? false : true;
                            }
                            if (element.type === 'hidden') {

                                sellerData[element.key] = relationData
                            }
                        })


                    const data = {
                        sellerData: sellerData,
                        id: this.props.id === undefined ? '' : this.props.id
                    }

                    this.props.action(data);
                    this.props.toggle();
                }
                else {

                    const data = {
                        sellerData: sellerData,
                        id: this.props.id === undefined ? '' : this.props.id
                    }
                    this.setState({ showResponseModal: true })
                    this.props.action(data);
                    this.props.toggle &&
                        this.props.toggle();
                }


            }


        }
    };


    // close Modal
    closeModal() {
        this.props.toggle();
        window.location.reload();
    }


    onClickReset = () => {
        const frm = document.getElementsByName('addform')[0];
        frm.reset();
        const resettingValues = this.state.formData;
        for (let key in resettingValues) {
            if (resettingValues[key].type !== 'hidden') {
                resettingValues[key].value = '';
                if (resettingValues[key].validation.required === true) {
                    resettingValues[key].valid = false;
                }
            }

            this.setState({ formData: resettingValues });
        }
    }

    propsChanged = (event, identifier, type) => {

        const updatedData = this.state.formData;

        const updatedElement = updatedData[identifier];

        if (type != 'checkbox') {

            updatedElement.value = event.target.value
        } else {
            updatedElement.value = event.target.checked
        }
        updatedElement.valid = this.isValidHandler(updatedElement.value, updatedElement.validation, type, updatedElement.regex, updatedElement.key)
        if (updatedElement.fieldValidation)
            updatedElement.fieldValid = this.isFieldValidHandler(updatedElement.value, updatedElement.fieldValidation, type, updatedElement.key)
        updatedElement.fieldError = { message: "" }
        updatedData[identifier] = updatedElement;

        this.setState({ formData: updatedData });
    };


    dobOnChange(e, form, pos) {
        const updatedData = this.state.formData;

        const updatedElement = updatedData[pos];

        if (form.elementConfig.name === 'year') {
            const monthElement = updatedData[pos + 1];
            const dayElement = updatedData[pos + 2];

            monthElement.value = ''
            monthElement.valid = false
            dayElement.value = ''
            dayElement.valid = false

            updatedData[pos + 1] = monthElement;
            updatedData[pos + 2] = dayElement;


            updatedElement.value = e.target.value;
            updatedElement.valid = this.isValidHandler(updatedElement.value, updatedElement.validation, form.type, updatedElement.regex);
            if (updatedElement.fieldValidation)
                updatedElement.fieldValid = this.isFieldValidHandler(updatedElement.value, updatedElement.fieldValidation, form.type, updatedElement.key)
            updatedElement.fieldError = { message: "" }
            updatedData[pos] = updatedElement;
            const server_year = new Date(updatedElement.validation.server_time).getYear() + 1900;
            const server_mon = new Date(updatedElement.validation.server_time).getMonth();


            const monthsArrRoot = [...this.state.monthsArrRoot]
            const monthsArr = monthsArrRoot.filter((month, index) => {
                if (updatedElement.value == server_year) {
                    return index <= server_mon
                } else if (updatedElement.value > server_year) {
                    return false
                } else {
                    if (updatedElement.value < updatedElement.validation.minYear) {
                        return false
                    } else {
                        return true
                    }
                }
            })


            let daysArr = []
            for (var i = 0; i < 31; i++) {
                daysArr.push(i + 1)
            }



            this.setState({
                daysArr: monthsArr.length ? daysArr : [],
                monthsArr
            })

        } else if (form.elementConfig.name === 'month') {
            updatedElement.value = e.target.value;
            updatedElement.valid = this.isValidHandler(updatedElement.value, updatedElement.validation, form.type, updatedElement.regex);
            if (updatedElement.fieldValidation)
                updatedElement.fieldValid = this.isFieldValidHandler(updatedElement.value, updatedElement.fieldValidation, form.type, updatedElement.key)
            updatedElement.fieldError = { message: "" }
            updatedData[pos] = updatedElement;

            const dayElement = updatedData[pos + 1];
            const yearElement = updatedData[pos - 1];

            const server_year = new Date(yearElement.validation.server_time).getYear() + 1900;
            const server_mon = new Date(yearElement.validation.server_time).getMonth() + 1;
            const server_day = new Date(yearElement.validation.server_time).getDate();

            dayElement.value = '';
            dayElement.valid = '';

            const leapyear = (year) => {
                return year % 100 === 0 ? year % 400 === 0 : year % 4 === 0;
            }

            const currentYearIsLeapYear = leapyear(parseInt(yearElement.value, 10))

            const MonthCheckForTotalDates = updatedElement.value == 1 || updatedElement.value == 3 || updatedElement.value == 5 || updatedElement.value == 7 || updatedElement.value == 8 || updatedElement.value == 10 || updatedElement.value == 12 ? 31 : updatedElement.value == 2 ? currentYearIsLeapYear ? 29 : 28 : 30

            let daysArr = [];

            const CheckDaysOnCurrentMonth = yearElement.value == server_year && updatedElement.value == server_mon ? server_day : MonthCheckForTotalDates

            for (var i = 0; i < CheckDaysOnCurrentMonth; i++) {
                daysArr.push(i + 1)
            }

            updatedData[pos - 1] = yearElement;
            updatedData[pos + 1] = dayElement;

            this.setState({
                daysArr
            })

        } else {

            updatedElement.value = e.target.value;
            updatedElement.valid = this.isValidHandler(updatedElement.value, updatedElement.validation, form.type, updatedElement.regex);
            if (updatedElement.fieldValidation)
                updatedElement.fieldValid = this.isFieldValidHandler(updatedElement.value, updatedElement.fieldValidation, form.type, updatedElement.key)
            updatedElement.fieldError = { message: "" }
            updatedData[pos] = updatedElement;
        }

        this.setState({ formData: updatedData });
    }

    render() {





        return (
            <div>
                {
                    this.props.formName === "user-details" &&
                    <Aux>
                        <div className="my-3 py-1 bg-green rounded-top position-relative d-flex flex-row flex-wrap justify-content-between align-items-center">
                            <div>
                                <p className=" text-uppercase py-2 pl-3  text-white mb-0 quattrocentosans regular"> {this.props.headerName}</p>
                            </div>
                            <div className="mr-md-3">
                                <button onClick={this.props.cancel} className="mr-1 btn btn-sm  bg-secondary text-white"><small>CANCEL</small></button>
                                <button onClick={this.handleSubmit} className="ml-1 btn btn-sm btn-red"><small>SAVE CHANGES</small></button>
                            </div>
                        </div>
                        {
                            this.props.headerName === 'DATE OF BIRTH INFORMATION' &&
                            <Form name="addForm" onSubmit={this.handleSubmit}>
                                <FormGroup >
                                    <div className="ml-md-3 ml-0 mb-2">
                                        <CustomInput onChange={() => this.props.onChangeRadio('blank')} className="quattrocentosans bold " type="radio" name="dobRadio" id="Blank Date" label="Blank Date" inline />
                                        <CustomInput onChange={() => this.props.onChangeRadio('set')} className="quattrocentosans bold " type="radio" name="dobRadio" id="Set Date" label="Set Date" inline />
                                    </div>
                                </FormGroup>
                            </Form>
                        }
                    </Aux>
                }


                <Form name="addform" onSubmit={this.handleSubmit} >


                    {
                        this.props.dobControlBool ?
                            <div className="col-12 pl-3 form-check form-check-inline justify-content-between d-block">
                                {
                                    !this.props.dobControl &&
                                    this.state.formData.map((form, pos) => (
                                        <div className={" pl-0 pr-md-3 pr-0 col-12"}>
                                            {
                                                (!form.valid && this.state.submitted) &&
                                                <div className="col-12">
                                                    <p className="text-right text-danger mb-0 ">*{form.elementConfig.label}
                                                        &nbsp;{form.validation.message}</p>
                                                </div>
                                            }
                                            <FormGroup
                                                key={form.name}
                                                className={"col-12 pl-3 form-check form-check-inline justify-content-between"}>

                                                <div className={" pt-2 h6 text-uppercase pl-md-3 pl-0 col-4 "}
                                                    htmlFor={form.elementConfig.name}

                                                    size="sm">{form.elementConfig.label}
                                                    {
                                                        form.validation.required &&
                                                        <span className="text-danger">*</span>
                                                    }
                                                </div>
                                                {
                                                    form.type === 'number' ?
                                                        <Input
                                                            className={" pt-2 h6 text-uppercase pl-md-3 pl-0 col-8 "}
                                                            type={form.type}
                                                            name={form.elementConfig.name}
                                                            id={form.elementConfig.name}
                                                            placeholder={form.elementConfig.placeholder}
                                                            value={form.value}
                                                            onChange={(e) => this.dobOnChange(e, form, pos)}
                                                        />
                                                        :
                                                        <Input
                                                            className={" pt-2 h6 text-uppercase pl-md-3 pl-0 col-8 "}
                                                            type={form.type}
                                                            name={form.elementConfig.name}
                                                            id={form.elementConfig.name}
                                                            value={form.value}
                                                            onChange={(e) => this.dobOnChange(e, form, pos)}
                                                        >
                                                            <option value={''}>select</option>
                                                            {
                                                                form.elementConfig.name === 'month' ?
                                                                    this.state.monthsArr.map((month, index) => (
                                                                        <option value={index + 1}>{month}</option>
                                                                    ))
                                                                    :
                                                                    this.state.daysArr.map((days, index) => (
                                                                        <option value={index + 1}>{days}</option>
                                                                    ))
                                                            }
                                                        </Input>

                                                }
                                            </FormGroup>
                                        </div>
                                    ))
                                }
                            </div>
                            :
                            <React.Fragment>
                                {
                                    this.props.viewMessageAdmin !== null &&
                                    <p className="text-center">{this.props.viewMessageAdmin}</p>
                                }
                                {
                                    this.props.compartments !== undefined && this.props.compartments !== null ?
                                        <div style={{ display: 'flex', justifyContent: 'space-around', textAlign: 'center' }}>

                                            {
                                                this.props.compartments.compartmentData.map(val => {
                                                    return (
                                                        val.value ?
                                                            <div style={{ width: '100%' }}>
                                                                <h4 style={{ textDecoration: 'underline' }}>{val.name}</h4>
                                                                <div className="compartmentResponsive">
                                                                    {
                                                                        !this.props.dobControl &&
                                                                        this.state.formData.map(
                                                                            (formElement, id) => {
                                                                                if (formElement.elementConfig.status) {
                                                                                    return (
                                                                                        <FormGroup key={id}
                                                                                            className={"col-4 pl-3 form-check form-check-inline justify-content-between flex-wrap"}>

                                                                                            <FormInput
                                                                                                key={id}
                                                                                                type={formElement.type}
                                                                                                name={formElement.elementConfig.name}
                                                                                                id={formElement.elementConfig.name}
                                                                                                placeholder={formElement.elementConfig.placeholder}
                                                                                                value={formElement.value}
                                                                                                label={formElement.elementConfig.label}
                                                                                                invalid={!formElement.valid}
                                                                                                isFieldValid={formElement.fieldValid}
                                                                                                shouldValidate={formElement.validation}
                                                                                                changed={(event) => this.propsChanged(event, id, formElement.type)}
                                                                                                submitted={this.state.submitted}
                                                                                                error={formElement.validation.message}
                                                                                                fieldError={formElement.fieldValidation ? formElement.fieldValidation.message : ""}
                                                                                                required={formElement.validation.required}
                                                                                                data={formElement.elementConfig}
                                                                                                formName={this.props.formName}
                                                                                                selects={this.props.selects}
                                                                                                selectKey={this.props.selectKey}
                                                                                                min={formElement.min !== undefined ? formElement.min : 0}
                                                                                                max={formElement.max !== undefined ? formElement.max : Infinity}
                                                                                            />
                                                                                        </FormGroup>
                                                                                    )
                                                                                }
                                                                            }
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                            :
                                                            <div style={{ width: '100%' }}>
                                                                <h4 style={{ textDecoration: 'underline' }}>{val.name}</h4>
                                                                <div className="compartmentResponsive">
                                                                    {
                                                                        !this.props.dobControl &&
                                                                        this.state.formData.map(
                                                                            (formElement, id) => {
                                                                                if (!formElement.elementConfig.status) {
                                                                                    return (
                                                                                        <FormGroup key={id}
                                                                                            className={"col-4 pl-3 form-check form-check-inline justify-content-between"}>
                                                                                            <FormInput
                                                                                                key={id}
                                                                                                type={formElement.type}
                                                                                                name={formElement.elementConfig.name}
                                                                                                id={formElement.elementConfig.name}
                                                                                                placeholder={formElement.elementConfig.placeholder}
                                                                                                value={formElement.value}
                                                                                                label={formElement.elementConfig.label}
                                                                                                invalid={!formElement.valid}
                                                                                                isFieldValid={formElement.fieldValid}
                                                                                                shouldValidate={formElement.validation}
                                                                                                changed={(event) => this.propsChanged(event, id, formElement.type)}
                                                                                                submitted={this.state.submitted}
                                                                                                error={formElement.validation.message}
                                                                                                fieldError={formElement.fieldValidation ? formElement.fieldValidation.message : ""}
                                                                                                required={formElement.validation.required}
                                                                                                data={formElement.elementConfig}
                                                                                                formName={this.props.formName}
                                                                                                selects={this.props.selects}
                                                                                                selectKey={this.props.selectKey}
                                                                                                min={formElement.min !== undefined ? formElement.min : 0}
                                                                                                max={formElement.max !== undefined ? formElement.max : Infinity}
                                                                                            />
                                                                                        </FormGroup>
                                                                                    )
                                                                                }
                                                                            }
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        :

                                        !this.props.dobControl &&
                                        this.state.formData.map(
                                            (formElement, id) => (
                                                formElement.type === 'checkbox' ?
                                                    <FormGroup
                                                        key={id}
                                                        className='col-3 pl-3 form-check form-check-inline justify-content-between'
                                                    >

                                                        <FormInput
                                                            key={id}
                                                            type={formElement.type}
                                                            name={formElement.elementConfig.name}
                                                            id={formElement.elementConfig.name}
                                                            placeholder={formElement.elementConfig.placeholder}
                                                            value={formElement.value}
                                                            label={formElement.elementConfig.label}
                                                            invalid={!formElement.valid}
                                                            isFieldValid={formElement.fieldValid}
                                                            shouldValidate={formElement.validation}
                                                            changed={(event) => this.propsChanged(event, id, formElement.type)}
                                                            submitted={this.state.submitted}
                                                            error={formElement.validation.message}
                                                            fieldError={formElement.fieldValidation ? formElement.fieldValidation.message : ""}
                                                            required={formElement.validation.required}
                                                            data={formElement.elementConfig}
                                                            formName={this.props.formName}
                                                            selects={this.props.selects}
                                                            selectKey={this.props.selectKey}
                                                        />

                                                    </FormGroup>
                                                    :
                                                    <FormGroup key={id}
                                                        className={formElement.type !== 'checkbox' ? "d-flex flex-row flex-wrap justify-content-between" : this.props.formName === 'inlineCheckbox1' || this.props.formName === 'inlineCheckbox2' ? "col-3 pl-3 form-check form-check-inline justify-content-between" : " col-12 pl-3 form-check form-check-inline justify-content-between "}>

                                                        <FormInput
                                                            key={id}
                                                            type={formElement.type}
                                                            name={formElement.elementConfig.name}
                                                            id={formElement.elementConfig.name}
                                                            placeholder={formElement.elementConfig.placeholder}
                                                            value={formElement.value}
                                                            label={formElement.elementConfig.label}
                                                            invalid={!formElement.valid}
                                                            isFieldValid={formElement.fieldValid}
                                                            shouldValidate={formElement.validation}
                                                            changed={(event) => this.propsChanged(event, id, formElement.type)}
                                                            submitted={this.state.submitted}
                                                            error={formElement.validation.message}
                                                            fieldError={formElement.fieldValidation ? formElement.fieldValidation.message : ""}
                                                            required={formElement.validation.required}
                                                            data={formElement.elementConfig}
                                                            formName={this.props.formName}
                                                            selects={this.props.selects}
                                                            selectKey={this.props.selectKey}
                                                            min={formElement.min !== undefined ? formElement.min : 0}
                                                            max={formElement.max !== undefined ? formElement.max : Infinity}
                                                        />
                                                    </FormGroup>
                                            )
                                        )

                                }
                            </React.Fragment>
                    }


                    {
                        this.props.formName === 'user-details' &&
                        <ModalFooter style={{ margin: "auto" }} >

                            <Button color=" btn-sm text-white bg-secondary" onClick={this.props.cancel}><small> CANCEL</small></Button>
                            <button className="btn-red btn-sm " type="submit"><small>SAVE CHANGES</small></button>
                        </ModalFooter>
                    }

                    {
                        this.props.formName === 'nonSubmittableForm' &&
                        <ModalFooter style={{ margin: "auto" }} >
                            <Button style={{ marginRight: "auto" }}
                                color="secondary" onClick={this.onClickReset}>Reset</Button>
                            <Button color="secondary" type="submit" >Next</Button>
                        </ModalFooter>
                    }

                    {
                        (this.props.formName !== 'nonSubmittableForm' && this.props.formName !== 'user-details') &&
                        <ModalFooter style={{ margin: "auto" }} >
                            {
                                !this.props.isReset &&
                                this.props.viewMessageAdmin === undefined &&
                                <Button style={{ marginRight: "auto" }}
                                    color="secondary" onClick={this.onClickReset}>Reset</Button>
                            }

                            {
                                this.props.formName === 'addRelation' &&
                                <Button
                                    color="secondary" onClick={this.props.toggleRelationGroup}>Back</Button>
                            }
                            {
                                this.props.viewMessageAdmin === undefined &&
                                <Button color="success" type="submit">Submit</Button>
                            }
                            {
                                !this.props.hideClose &&
                                <Button color="danger" onClick={this.props.toggle}>Cancel</Button>
                            }
                        </ModalFooter>
                    }

                </Form>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { loading } = state.addSeller;
    const newdata = (!loading) ? state.addSeller.response : '';
    const responseCode = (!loading) ? state.addSeller.responseCode : '';

    const { sellCreditsLoading } = state.sellCredit;
    const sellCreditsResponse = (!sellCreditsLoading) ? state.sellCredit.data.data : '';
    const sellCreditsResponseCode = (!sellCreditsLoading) ? state.sellCredit.data.status : '';

    const { revokeCreditsLoading } = state.revokeCredit;
    const revokeCreditsResponse = (!revokeCreditsLoading) ? state.revokeCredit.data.data : '';
    const revokeCreditsResponseCode = (!revokeCreditsLoading) ? state.revokeCredit.data.status : '';


    const { editLoading } = state.updateSeller;
    const editSellerResponse = (!editLoading) ? state.updateSeller.response.data : '';
    const editSellerResponseCode = (!editLoading) ? state.updateSeller.responseCode : '';


    const { addRelationGroupLoading } = state.addRelationGroup;
    const addRelationGroupResponse = (!addRelationGroupLoading) ? state.addRelationGroup.data.data : '';
    const addRelationGroupResponseCode = (!addRelationGroupLoading) ? state.addRelationGroup.data.status : '';






    return {
        newdata,
        loading,
        responseCode,

        editLoading,
        editSellerResponse,
        editSellerResponseCode,

        sellCreditsLoading,
        sellCreditsResponse,
        sellCreditsResponseCode,

        revokeCreditsLoading,
        revokeCreditsResponse,
        revokeCreditsResponseCode,

        addRelationGroupResponse,
        addRelationGroupResponseCode,





    };
}

const connectedForm = connect(mapStateToProps)(DynamicForm);
export default withRouter(connectedForm); 


// WEBPACK FOOTER //
// ./src/_components/common/Form/index.jsx